import WizardHeader from "./WizardHeader";
import BreadCrumb from "../HeaderComponents/BreadCrum";

export default function WizardShell({ activeIndex, onGoto, children }) {
  return (
    <div className="pb4">
      <div className="w100 flexbread">
        <div className="divbreadcrum w90">
          <BreadCrumb />
        </div>
      </div>
      <WizardHeader activeIndex={activeIndex} goToStep={onGoto} />
      <div className="wz-content">{children}</div>
    </div>
  );
}
